import {TripCollection} from "../Trip";
import altele from "../../../assets/child/altele.jpg";

const dayChildAltele: TripCollection = {
    imageSrc: altele,
    trips: [
        {
            name: "Târgu Mureş",
            route: "",
            days: [
                [
                    {
                        locationName: "",
                    },
                ]
            ],
            notes: ""
        },
        {
            name: "Ţara Haţegului",
            route: "",
            days: [
                [
                    {
                        locationName: "",
                    },
                ]
            ],
            notes: ""
        },
        {
            name: "Vulcanii Noroioşi Buzău",
            route: "",
            days: [
                [
                    {
                        locationName: "",
                    },
                ]
            ],
            notes: ""
        }
    ]
}

export default dayChildAltele;